import { createContext } from "react";
import {
  CartPosition,
  Branch,
  DeliveryAddress,
  DeliveryMethod,
  DeliveryType,
  DeliveryTimeType,
  MenuPage
} from "../types/cart.types";

interface AppContextProps {
  // Cart
  cart: CartPosition[];
  setCart: (cart: CartPosition[] | ((prevCart: CartPosition[]) => CartPosition[])) => void;
  total_ammount: number;

  // Restaurant Slug (from URL)
  restaurantSlug: string | null;
  setRestaurantSlug: (slug: string | null) => void;

  // Branch & Restaurant
  selectedBranch: Branch | null;
  setSelectedBranch: (branch: Branch | null) => void;
  isOpen: boolean | undefined;

  // Delivery
  deliveryType: DeliveryType;
  setDeliveryType: (type: DeliveryType) => void;
  deliveryAdress: DeliveryAddress | null;
  setDeliveryAdress: (address: DeliveryAddress | null) => void;
  apertmenNumber: string;
  setApertmenNumber: (number: string) => void;
  deliveryNote: string;
  setDeliveryNote: (note: string) => void;
  selectedDeliveryMethod: DeliveryMethod | null;
  setSelectedDeliveryMethod: (method: DeliveryMethod | null) => void;
  isOverMinOrderDeliveryPrice: boolean;

  // Order Timing
  deliveryTimeType: DeliveryTimeType;
  setDeliveryTimeType: (type: DeliveryTimeType) => void;
  orderDate: string | null;
  setOrderDate: (date: string | null) => void;
  orderTime: string | null;
  setOrderTime: (time: string | null) => void;

  // Services
  additionalSections: any; // TODO: type this properly
  setAdditionalSections: (sections: any) => void;
  serviceData: any; // TODO: type this properly
  setServiceData: (data: any) => void;
  serviceTime: any; // TODO: type this properly
  setServiceTime: (time: any) => void;
  serviceResurces: Record<string, any>; // TODO: type this properly
  setServiceResurces: (resources: Record<string, any>) => void;

  // User Info
  name: string;
  setName: (name: string) => void;
  email: string;
  setEmail: (email: string) => void;
  number: string;
  setNumber: (number: string) => void;
  isEmailValid: boolean;
  emailError: string | null;
  isPhoneValid: boolean;
  phoneError: string | null;
  appliedCoupon: any;
  setAppliedCoupon: any;
  couponCode: string;
  setCouponCode: any;

  // UI State
  mealName: string;
  setMealName: (name: string) => void;
  selectedCategory: any; // TODO: type this properly
  setSelectedCategory: (category: any) => void;
  isMain: boolean;
  setIsMain: (isMain: boolean) => void;
  scroll: number;
  setScroll: (scroll: number) => void;
  searchQuery: string;
  setSearchQuery: (q: string) => void;

  // Order flow
  isOrder: boolean;
  setIsOrder: (isOrder: boolean) => void;

  // Page Navigation
  currentPage: MenuPage;
  navigateTo: (page: MenuPage) => void;
  goBack: () => void;
}

export const AppContext = createContext<AppContextProps | undefined>(undefined);
